module.exports = __webpack_public_path__ + "img/SLT_5953-Bearbeitet.37c38539.jpg";